import type { LookalikeRatio } from "@common/interfaces/KYDMarketing";
import { InstagramAccount } from "../../types";

export type PageLookalikeAudienceFormValues = {
  facebookPageId?: string;
  facebookPageName?: string;
  instagramPageId?: string;
  instagramPageName?: string;
  name: string;
  audienceMode?: "engagers" | "lookalike";
  createLookalike: boolean;
  lookalike: {
    name: string;
    ratio: LookalikeRatio;
  };
  type: "page_lookalike";
};

export type StepConfig = {
  id: number;
  title: string;
  subtitle?: string;
  component: React.ComponentType<StepProps>;
  nextButtonText: string;
  canProceed: (form: any) => boolean;
};

export type StepProps = {
  pages: Array<{
    id: string;
    name: string;
  }>;
  instagramAccounts: InstagramAccount[];
  onFetchInstagramForFacebookPage?: (
    facebookPageId: string
  ) => void | Promise<InstagramAccount[]>;
  lookalikeOptions: Array<{
    title: string;
    description: string;
    value: LookalikeRatio;
    icon: React.ReactElement;
    iconBgColor: string;
    isRecommended: boolean;
  }>;
};

export const buildLookalikeName = (
  name: string,
  ratio: LookalikeRatio
): string => `${name} (Lookalike ${ratio})`;
